<template>
  <div class="content">
    <p>{{ $t('thankYou.title') }}</p>
    <p>{{ $t('thankYou.subTitle') }}</p>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('Phone number is: ' + this.$store.state.phoneNumber);
    console.log('Email adress is: ' + this.$store.state.email);
    console.log(
      'Interested Languages adress is: ' + this.$store.state.interestedLanguages
    );
    console.log(
      'Selected Languages are: ' + this.$store.state.selectedLanguages
    );
    console.log('Customer profession : ' + this.$store.state.profession);
    fetch(
      'https://flow.zoho.eu/20063454075/flow/webhook/incoming?zapikey=1001.71aa9cf7c874925425ad8a3c19561562.74bae2cb7b9ede723f5101110014ba36&isdebug=false',
      {
        method: 'POST',
        headers: {
          'content-type': 'text/plain',
          'Accept-Language': 'en-US',
          'Content-Language': 'en-US',
          accept: '*/*',
          'Access-Control-Allow-Origin': '*',
        },
        referrerPolicy: 'no-referrer',
        mode: 'no-cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        body: JSON.stringify({
          phoneNumber: this.$store.state.phoneNumber,
          email: this.$store.state.email,
          interestedLanguages: this.$store.state.interestedLanguages,
          selectedLanguages: this.$store.state.selectedLanguages,
          profession: this.$store.state.profession,
        }),
      }
    );
  },
};
</script>
